<template>
  <div class="coat">
    <!-- 头部 -->
    <div class="section">
      <img src="../assets/news/newsheader.jpg" alt="" />
    </div>
    <!-- 内容提示 -->
    <div class="tips">
      <div>
        <img src="../assets/product/icon.png" alt="" />
        <span>首页 > 新闻动态 > 新闻</span>
      </div>
    </div>
    <!-- 整体内容 -->
    <div class="main">
      <!-- 新闻详情页 -->
      <div  class="detail">
        <div class="title">十四五工业绿色发展再接再厉</div>
        <p class="time">发布时间：2022-01-13</p>
        <div class="line"></div>
        <div class="content">
          工信部近日对外公布《“十四五”工业绿色发展规划》，阐述“十四五”期间工业绿色发展的总体思路，明确了碳排放强度持续下降、
          污染物排放强度显著下降等发展目标和具体工作安排。特别提出，以数字化转型驱动生产方式变革。
        </div>
        <div>
          <img
            style="width: 80%; height: auto"
            src="../assets/news/newscontent.jpg"
            alt=""
          />
        </div>
        <div class="content">
          《规划》提出，到2025年，我国能源效率稳步提升，规模以上工业单位增加值能耗降低13.5%。资源利用水平明显提高，大宗工业固废综合利用率达到57%，
          主要再生资源回收利用量达到4.8亿吨，单位工业增加值用水量降低16%。污染物排放强度显著下降，
          重点行业主要污染物排放强度降低10%。绿色制造体系日趋完善，重点行业和重点区域绿色制造体系基本建成，绿色环保产业产值达到11万亿元。
        </div>
        <div class="content" style="margin-top: 30px">
          规划》明确“聚焦一大行动、构建两大体系、推动六大转型、实施八大工程”的整体工作安排。即以实施工业领域碳达峰行动为引领，
          着力构建完善的绿色低碳技术体系和绿色制造支撑体系。
        </div>
        <div class="content" style="margin-top: 30px">
          规划强调，到2025年，工业产业结构、生产方式绿色低碳转型取得显著成效，绿色低碳技术装备广泛应用，能源资源利用效率大幅提高，绿色制造水平全面提升。明确要采用工业互联网、大数据、
          5G等新一代信息技术提升能源、资源、环境管理水平，深化生产制造过程的数字化应用，赋能绿色制造。
        </div>
        <div class="content" style="margin-top: 30px">
          设备设施的精细化管理，能减少不必要的关键零部件定时更换，进一步降低非必要性的产能，以此实现节能减碳，从而助力向“碳达峰”的目标靠近。雅格科技自成立以来，紧跟国家政策导向，
          不断探索智能化领域的创新与发展，实现设备设施精细化管理，推动节能降耗和城市绿色节能发展。
        </div>
        <div class="content" style="margin-top: 30px">
          雅格技设备健康诊断系统，利用5G、工业互联网、云计算等新一代信息技术，结合实时监测数据、历史趋势图、数据图谱、告警情况分析报表等协助用户顺利解决传统设备维护所面临的困境，
          助力企业实现全流程、全生命周期精细化管理。
          系统借助高精度、高采样率的智能监测传感器，对机械设备进行不间断状态监测，并以数字化呈现相关运行情况。基于深度学习技术构建的智能故障诊断算法（模型），通过智能故障分析库确认故障位置及运行状态，减少设备巡检的次数，降低人力成本，提高轨道交通、工业制造等行业关键设备的使用寿命。
          2020年，历时数月的软件开发测试和数据库模型建立，大数据平台开始投入试用。仅一周时间，设备健康诊断系统就预测环控机房某台风机（给站厅供新风）故障，并发出预警信号，预防事故发生。
        </div>
        <div>
          <img
            @click="backnewsClick()"
            style="margin: 50px auto; width: 100px; height: 100px"
            src="../assets/news/back.png"
            alt=""
          />
        </div>
        <div class="line"></div>
        <!-- 索引 -->
        <div class="index" style="margin-top: 50px">上一篇：第一篇</div>
        <div class="index">
          <!-- 下一篇：雅格科技前三季度利润超二十亿！拍同行第一 -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
     
    };
  },
  mounted() {},
  computed: {},
  methods: {
    // 跳转到新闻详情页
   
    // 返回新闻首页
    backnewsClick() {
      this.$router.push('/news');
    },
  },
};
</script>
<style scoped lang="scss">
.coat {
  width: 100%;

  .section {
    margin: 0 0 -5px;
    position: relative;
    color: #ffffff;
    img {
      width: 100%;
      height: auto;
    }
  }
  // 内容提示
  .tips {
    width: 100%;
    height: 50px;
    line-height: 50px;
    cursor: pointer;
    div {
      margin-left: 12%;
      img {
        width: 12px;
        height: 12px;
        vertical-align: middle;
      }
      span {
        font-size: 10px;
        color: #808080;
        margin: 0 6px;
        display: inline-block;
        vertical-align: middle;
      }
    }
  }
  // 整体内容
  .main {
    width: 100%;
    background: #f5f5fa;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #405c80;
    padding: 40px 0;
    box-sizing: border-box;
    text-align: center;
    // 新闻详情
    .detail {
      cursor: pointer;
      .title {
        color: #333333;
        font-size: 25px;
      }
      // 发布时间
      .time {
        color: #a5a5a5;
        font-size: 15px;
      }
      .line {
        width: 90%;
        height: 1px;
        background: #cccccc 00;
        border: 1px solid #cccccc;
        margin: 0 5% 20px;
      }
      // 新闻具体内容
      .content {
        width: 80%;
        margin: 10px 10%;
        text-align: left;
        line-height: 30px;
        font-size: 17px;
        text-indent: 2em;
      }
      // 索引
      .index {
        width: 80%;
        margin: 10px 10%;
        text-align: left;
        line-height: 20px;
        font-size: 17px;
      }
    }
  }
}
</style>
